export enum OLVIDO_PASS_TYPES {
  FORM_RESTABLECER_HANDLE_CHANGE = 'FORM_RESTABLECER_HANDLE_CHANGE',
  INPUT_EMAIL = '1',
  INPUT_TELEFONO = '2',
  FORM_VERIFICAR_HANDLE_CHANGE = 'FORM_VERIFICAR_HANDLE_CHANGE',
  FORM_PASSWORD_HANDLE_CHANGE = 'FORM_PASSWORD_HANDLE_CHANGE',
  FORM_PASSWORD_ADD_ERRORS = 'FORM_PASSWORD_ADD_ERRORS',
  CLEAR = 'CLEAR',
  KEY_EMAIL = 'KEY_EMAIL',
}
